import { Reducer } from 'redux';
import { SearchItem } from '../../../../models/search-item';
import { Aggregate } from '../../../../models/aggregate';
import { PayloadAction } from '../../../../../store/payload-action';


export interface EntityFilterDatas {
  filterItems: SearchItem[];
  lastAgg: Aggregate;
}
export interface EntityFilterState {
  datas: EntityFilterDatas;
  loading: boolean;
  error: any;

}

const FILTER_ITEMS_INITIAL_STATE: EntityFilterState = {
  datas: {
    filterItems: [],
    lastAgg: null
  },
  loading: false,
  error: null
};
// const FILTER_ITEMS_INITIAL_STATE = {
//   filterItems: [],
//   lastAgg: null,
//   loading: false,
//   error: null,
// };

export class EntityFilterActionConstant {
  static readonly ADD_FILTER_ITEMS_START = '[FilterEntity].ADD_FILTER_ITEMS_START';
  static readonly ADD_FILTER_ITEMS_SUCCEEDED = '[FilterEntity].ADD_FILTER_ITEMS_SUCCEEDED';
  static readonly ADD_FILTER_ITEMS_FAILED = '[FilterEntity].ADD_FILTER_ITEMS_FAILED';

  static readonly REMOVE_FILTER_ITEM_STARTED = '[FilterEntity].REMOVE_FILTER_ITEM_STARTED';
  static readonly REMOVE_FILTER_ITEM_SUCCEEDED = '[FilterEntity].REMOVE_FILTER_ITEM_SUCCEEDED';
  static readonly REMOVE_FILTER_ITEM_FAILED = '[FilterEntity].REMOVE_FILTER_ITEM_FAILED';

  static readonly UPDATE_FILTER_ITEMS_START = '[FilterEntity].UPDATE_FILTER_ITEMS_START';
  static readonly UPDATE_FILTER_ITEMS_SUCCEEDED = '[FilterEntity].UPDATE_FILTER_ITEMS_SUCCEEDED';
  static readonly UPDATE_FILTER_ITEMS_FAILED = '[FilterEntity].UPDATE_FILTER_ITEMS_FAILED';

  static readonly REMOVE_ALL_FILTER_ITEMS_SUCCEEDED = '[FilterEntity].REMOVE_ALL_FILTER_ITEMS_SUCCEEDED';
  static readonly REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED = '[FilterEntity].REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED';
}

export const entityFilterReducer: Reducer<EntityFilterState> = (state: EntityFilterState = FILTER_ITEMS_INITIAL_STATE, action: PayloadAction<EntityFilterDatas>) => {
  switch (action.type) {
    case EntityFilterActionConstant.ADD_FILTER_ITEMS_START:
    case EntityFilterActionConstant.UPDATE_FILTER_ITEMS_START:
    case EntityFilterActionConstant.REMOVE_FILTER_ITEM_STARTED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EntityFilterActionConstant.UPDATE_FILTER_ITEMS_SUCCEEDED:
      const toReplace: SearchItem = action.payload.filterItems[0];
      let found = false;
      let searchItems = state.datas.filterItems.map(aFilterItem => {
        if (aFilterItem.path === toReplace.path && aFilterItem.operator === toReplace.operator) {
          found = true;
          return toReplace;
        } else {
          return aFilterItem;
        }
      });
      if (!found) {
        searchItems = [...searchItems, toReplace];
      }
      return {
        ...state,
        datas: {
          ...state.datas,
          filterItems: searchItems,
          lastAgg: action.payload.lastAgg
        },
        loading: false,
        error: null,
      };
    case EntityFilterActionConstant.ADD_FILTER_ITEMS_SUCCEEDED:
      const add = state.datas;
      if (!action.payload.filterItems[0].operator) {
        add.filterItems = add.filterItems.concat(action.payload.filterItems[0]);
      } else {
        const existingFilterItemRange = add.filterItems.find(existingFilterItem => existingFilterItem.operator === action.payload.filterItems[0].operator && existingFilterItem.path === action.payload.filterItems[0].path);
        if (!existingFilterItemRange) {
          add.filterItems = add.filterItems.concat(action.payload.filterItems[0]);
        } else {
          add.filterItems[add.filterItems.indexOf(existingFilterItemRange)] = action.payload.filterItems[0];
        }
      }

      add.lastAgg = action.payload.lastAgg;
      return {
        ...state,
        datas: add,
        loading: false,
        error: null,
      };
      case EntityFilterActionConstant.ADD_FILTER_ITEMS_FAILED:
      case EntityFilterActionConstant.REMOVE_FILTER_ITEM_FAILED:
      case EntityFilterActionConstant.UPDATE_FILTER_ITEMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case EntityFilterActionConstant.REMOVE_ALL_FILTER_ITEMS_SUCCEEDED:
      return {
        ...state,
        datas: {
          filterItems: [],
          lastAgg: null
        },
        loading: false,
        error: null,
      };
    case EntityFilterActionConstant.REMOVE_FILTERS_AND_KEEP_LAST_AGG_SUCCEEDED:
      return {
        ...state,
        datas: {
          ...state.datas,
          filterItems: []
        },
        loading: false,
        error: null,
      };
    case EntityFilterActionConstant.REMOVE_FILTER_ITEM_SUCCEEDED:
      const filterItem: SearchItem = action.payload.filterItems[0];
      let oldLastAgg = state.datas.lastAgg;
      let remove: SearchItem[];
      if (!filterItem.operator) {
        remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.value !== filterItem.value);
      } else {
        remove = state.datas.filterItems.filter(item => item.path !== filterItem.path || item.operator !== item.operator);
      }
      if (remove.length === 0) {
        oldLastAgg = null;
      }
      return {
        ...state,
        datas: {
          filterItems: remove,
          lastAgg: oldLastAgg
        },
        loading: false,
        error: null,
      };
  }
  return state;
};
